import { FunctionComponent } from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { Div } from '@gaiads/telia-react-component-library';
import GetStarted from './GetStarted/GetStarted';
import GroupSettings from './GroupSettings/GroupSettings';
import UserGroups from './UserGroups/UserGroups';
import Users from './Users/Users';
import Approval from './Approval/Approval';

const Onboarding: FunctionComponent = () => {
  const { path } = useRouteMatch();
  // Fetch onboarding data
  // Is onboarding in which state - completed or not completed
  // Redirect to right stage

  return (
    <Div>
      <Switch>
        <Route path={`${path}/getstarted`} component={GetStarted} />
        <Route path={`${path}/usergroups`} component={UserGroups} />
        <Route path={`${path}/users`} component={Users} />
        <Route path={`${path}/groupsettings`} component={GroupSettings} />
        <Route path={`${path}/approval`} component={Approval} />
        <Redirect to={`${path}/getstarted`} />
      </Switch>
    </Div>
  );
};

export default Onboarding;
